{
  "title": "Submit Your Final Work",
  "description": "Formally submit your finished work to the competition and move it into judging.",
  "headings": [
    "What You'll Accomplish",
    "Before You Start",
    "Steps",
    "What You'll See",
    "Warning",
    "Still Stuck?"
  ],
  "summary": "Once finished, your work is formally submitted to the competition and moves into judging.",
  "prerequisites": [
    "All required fields are complete",
    "Your files have uploaded successfully",
    "Your submission is marked \"Ready\"",
    "The submission deadline has not passed (use the date shown on the competition page and the submission page, which is the current round's deadline)"
  ],
  "steps": [
    {
      "title": "1. Review your submission",
      "description": "In My Competitions → Submission → Submission Details, check the title, description, and files."
    },
    {
      "title": "2. Confirm the status is \"Ready\"",
      "description": "If it's still \"Draft\", click \"Mark as Ready\" before continuing."
    },
    {
      "title": "3. Click \"Submit\"",
      "description": "Confirm the prompt and submit; you cannot undo this step afterward."
    }
  ],
  "afterward": [
    "Status changes to \"Submitted\"",
    "A submission timestamp is shown",
    "Editing is disabled"
  ],
  "warning": "Once submitted, your work may no longer be editable. Confirm everything before submitting.",
  "nextSteps": "If you can see \"Submit\" but can't click it, see \"Submission Failed\".",
  "faq": [
    {
      "q": "Does uploading a file count as submitting?",
      "a": "No. Uploading only saves a draft. You must mark it \"Ready\" and click \"Submit\" separately for it to be formally submitted."
    }
  ]
}
